// Мобайл горимын хандалт: "Бага анги" — зөвхөн бага ангийн багш (албан тушаалд "Бага анги" орсон) ба удирдлага.
const MANAGER_ROLES = ["CEO", "Админ", "Удирдлага", "Менежер"];

export const canElementary = (p) => !!p && (MANAGER_ROLES.includes(p.role) || /бага анги/i.test(p.position || ""));
